function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.88 6c-.95.43-1.97.7-3.04.84 1.1-.65 1.93-1.7 2.33-2.92-1.02.6-2.16 1.05-3.36 1.28-.9-1.03-2.3-1.67-3.8-1.67-2.9 0-5.3 2.37-5.3 5.3 0 .4.1.8.2 1.2C9.5 9.8 5.6 7.7 3 4.5c-.46.78-.7 1.7-.7 2.66 0 1.83.9 3.45 2.33 4.4a5.22 5.22 0 01-2.4-.67c0 2.53 1.83 4.7 4.24 5.2-.44.1-.9.2-1.4.2-.33 0-.66-.08-1-.1.7 2.1 2.64 3.6 4.95 3.62-1.8 1.4-4.1 2.26-6.56 2.26-.43 0-.85-.03-1.26-.08 2.34 1.5 5.12 2.36 8.1 2.36 9.72 0 15.04-8.05 15.04-15v-.7c1-.7 1.9-1.67 2.6-2.7z",
  className: ""
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.ac376369.svg";
export { ForwardRef as ReactComponent };